import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getBannersList, getOffers, sendEmail, getOffers2 , updateUser, getAddressByUserId, saveAddressByUserId, updateAddressByUserId, deleteAddressById } from "../api";

//Sección home 
export const ListaBanners = () => {
    const query = useQuery(
      ['listaBanners'],
      () => getBannersList(),
      {
        staleTime: 1000 * 60 * 10,// 10 Minutos
      }
    );
    return query;
  }
//Seccion Ofertas del día
export const useListaOfertas = () => {
  const query = useQuery(
    ['ofertas'],
    () => getOffers(),
    {
      staleTime: 1000 * 60 * 10,// 10 Minutos
    }
  );
  return query;
}

export const useOfertas = () => {
  const queryClient = useQueryClient();
  const query = useMutation({
    mutationKey: ['mutateUseOfertas'],
    mutationFn: getOffers2,
    onSuccess: (status) => {
      queryClient.setQueryData(
        ['useOfertas'],
        status
      );
    },
  });

  return query;
};

export const useSendEmail = () => {
  const query = useMutation({
    mutationKey: ['useSendEmail'],
    mutationFn: sendEmail,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useUpdateUser = () => {
  const query = useMutation({
    mutationKey: ['useUpdateUser'],
    mutationFn: updateUser,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useSaveAddress = () => {
  const query = useMutation({
    mutationKey: ['useSaveAddress'],
    mutationFn: saveAddressByUserId,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};


export const useGetAddressByUserId = () => {
  const query = useMutation({
    mutationKey: ['useGetAddressByUserId'],
    mutationFn: getAddressByUserId,
    onSuccess: (status) => {
      return status;
    },
  });
  return query;
};

export const useActualizarDireccionActiva = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['mutateActualizarDireccionActiva'],
    mutationFn: updateAddressByUserId,
    onSuccess: () => {
      // Opcional: actualizas el caché si tienes una lista de direcciones
      queryClient.invalidateQueries(['listaDirecciones']);
    },
  });
};

export const useEliminarDireccion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['eliminarDireccion'],
    mutationFn: deleteAddressById,
    onSuccess: () => {
      queryClient.invalidateQueries(['direccionesUsuario']);
    },
  });
};


